import { NavLink } from 'react-router-dom';
import { Building2, Briefcase, Sparkles, LayoutDashboard, Utensils, LogOut } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAuth } from '@/hooks/useAuth';

// Sales portal nav. Research ships in Phase 1; the rest are placeholders that
// land as Phases 2-4 arrive.
const NAV = [
  { to: '/research', label: 'Research', icon: Building2, ready: true },
  { to: '/corporate', label: 'Corporate', icon: Briefcase, ready: true },
  { to: '/subscription', label: 'OneLife', icon: Sparkles, ready: false },
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard, ready: false },
];

export function SalesSidebar() {
  const { user, signOut } = useAuth();
  const email = user?.email ?? '';
  const name = (user?.user_metadata as any)?.full_name ?? email;
  return (
    <aside className="hidden h-full w-56 shrink-0 border-r border-border/60 bg-card/40 px-3 py-4 md:flex md:flex-col">
      <div className="mb-4 flex items-center gap-2 px-2">
        <div className="flex h-8 w-8 items-center justify-center rounded-md bg-gradient-to-br from-[#252D63] to-[#51BFAA] text-white shadow-sm">
          <Utensils className="h-4 w-4" />
        </div>
        <div>
          <div className="text-sm font-semibold leading-tight">Flax</div>
          <div className="text-2xs text-muted-foreground">Sales</div>
        </div>
      </div>
      <nav className="flex-1 space-y-0.5 overflow-y-auto">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                'group flex items-center justify-between rounded-md px-2 py-1.5 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-foreground',
                isActive && 'bg-accent text-foreground',
                !item.ready && 'pointer-events-none opacity-40',
              )
            }
          >
            <span className="flex items-center gap-2">
              <item.icon className="h-4 w-4" />
              {item.label}
            </span>
            {!item.ready && <span className="text-[9px] uppercase tracking-wide">soon</span>}
          </NavLink>
        ))}
      </nav>
      <div className="mt-2 space-y-2 border-t border-border/60 px-2 pt-3">
        {email && (
          <div className="min-w-0">
            <div className="truncate text-xs font-medium">{name}</div>
            {name !== email && <div className="truncate text-2xs text-muted-foreground">{email}</div>}
          </div>
        )}
        <button
          onClick={() => signOut()}
          className="flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-xs text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
        >
          <LogOut className="h-3.5 w-3.5" /> Sign out
        </button>
        <span className="block text-2xs text-muted-foreground">sales.flaxfoods.in</span>
      </div>
    </aside>
  );
}
